(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["merch-logo-upload"] && !Shopify.designMode) return;
  try {
    const ALLOWED = ['png', 'jpg', 'jpeg', 'svg', 'pdf', 'ai', 'eps'];
  customElements.define(
    'merch-logo-upload',
    class extends HTMLElement {
      connectedCallback() {
        const input = this.querySelector('.merch-logo__input');
        const error = this.querySelector('.merch-logo__error');
        const zone = this.querySelector('[data-zone]');
        const fileRow = this.querySelector('[data-file]');
        const maxBytes = Number(this.dataset.maxMb) * 1024 * 1024;
        const show = (file) => {
          fileRow.hidden = !file;
          zone.hidden = Boolean(file);
          this.querySelector('[data-name]').textContent = file ? file.name : '';
        };
        input.addEventListener('change', () => {
          error.hidden = true;
          const file = input.files[0];
          if (!file) return show(null);
          const ext = file.name.split('.').pop().toLowerCase();
          let message = '';
          if (!ALLOWED.includes(ext)) message = 'Please upload a PNG, JPG, SVG, PDF, AI or EPS file.';
          else if (file.size > maxBytes) message = `That file is over ${this.dataset.maxMb} MB. Upload a smaller version, or skip it and we'll collect it when we reach out.`;
          if (message) {
            input.value = '';
            error.textContent = message;
            error.hidden = false;
            return show(null);
          }
          show(file);
        });
        this.querySelector('[data-clear]').addEventListener('click', () => {
          input.value = '';
          show(null);
          zone.focus();
        });
        ['dragenter', 'dragover'].forEach((type) =>
          zone.addEventListener(type, (e) => { e.preventDefault(); zone.classList.add('is-over'); })
        );
        ['dragleave', 'drop'].forEach((type) =>
          zone.addEventListener(type, () => zone.classList.remove('is-over'))
        );
        zone.addEventListener('drop', (e) => {
          e.preventDefault();
          if (!e.dataTransfer?.files?.length) return;
          input.files = e.dataTransfer.files;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }
  );
  } catch(e) { console.error(e); }
})();

})();
